export default {
  setData(state, data) {
    state.statistics = data.stats;
    state.groupBy = data.groupBy;
    state.startDate = data.startDate;
    state.endDate = data.endDate;
    state.loaded = true;
    state.rights = {};
    Object.keys(data.stats).forEach((right) => {
      state.rights[right] = Object.keys(data.stats[right]);
      state.rights[right].forEach((component) => { state.dataLoaded[component] = true; });
    });
  },
  updateConfig(state, config) {
    state.config = config;
    state.loaded = false;
  },
  setLoading(state, status) {
    state.loading = status;
  },
};
